import React from 'react';
import {connect} from 'react-redux';

import {FormattedMessage} from 'react-intl';
import {formatDateWithTime} from '../utils/dateTimeUtils';
import setScannerTestModeAction from "../actions/events/setScannerTestModeAction";

class ScannerDetails extends React.Component {

    capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    getRelevantData = () => {
    if (this.testDataExists() && this.props.testData.onTestData) {
      return this.props.testData;
    } else {
      return this.props.data;
    }
  };

  testDataExists = () => !!(this.props.testData && this.props.testData.dateInMillis && this.props.testData.version);

  toggleScannerData = () => {
    this.props.setScannerTestMode(this.props.userId, !this.props.testData.onTestData);
  };

  render() {
    let scannerData = this.getRelevantData();
    let testDataExists = this.testDataExists();
    let scannerClasses = 'scanner' + ((testDataExists && this.props.testData.onTestData) ? ' testData' : '');
    console.log(scannerData);
    return (
      <div className="scannerDetails">
        {scannerData &&
        <div>
          <p className={scannerClasses}>
            {<FormattedMessage
              id="viboScanner.lastScan"/>}{" "}{formatDateWithTime(new Date(parseInt(scannerData.dateInMillis, 10)))}
          </p>
          <p className={scannerClasses}>
            {<FormattedMessage id="viboScanner.version"/>}{" "}{scannerData.version}
          </p>
          {scannerData.historyPlatforms && scannerData.historyPlatforms.length && <p className={scannerClasses}>
            {<FormattedMessage id="viboScanner.historyPlatforms"/>}{" "}{scannerData.historyPlatforms.map(this.capitalize).join(', ')}
          </p>}
          {testDataExists &&
          <p className="switchLink" onClick={this.toggleScannerData}>
            {<FormattedMessage id="viboScanner.switchLink"
                               values={{deployment: (this.props.testData.onTestData ? 'production' : 'test')}}/>}
          </p>
          }
        </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.user.data.uploadedFilesData,
  testData: state.user.data.uploadedFilesDataTest,
  userId: state.user.data.id
});

const mapDispatchToProps = {
  setScannerTestMode: setScannerTestModeAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScannerDetails)



// WEBPACK FOOTER //
// ./src/routers/scannerDetails.js